<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon v-if="isIncluded" icon="SlashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openExcludeConfirm" />
      <feather-icon v-if="isExcluded" icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openIncludeConfirm" />
    </div>
</template>

<script>
export default {
  name: 'CellSampleActions',
  computed: {
    isExcluded() {
      return this.params.data.isGoldExcluded;
    },
    isIncluded() {
      return !this.params.data.isGoldExcluded;
    }
  },
  methods: {
    openIncludeConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmInclusion'),
        accept: this.includeSample
      });
    },

    openExcludeConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GradeControl.Sample.ConfirmExclusion'),
        accept: this.excludeSample
      });
    },

    excludeSample () {
      this.params.data.isGoldExcluded = true;
      this.params.context.componentParent.updateSample(this.params.data);
    },

    includeSample () {
      this.params.data.isGoldExcluded = false;
      this.params.context.componentParent.updateSample(this.params.data);
    }
  }
}
</script>
